const observer = new MutationObserver(() => {
  const wrappers = document.querySelectorAll('.appstle_input_wrapper');
  
  wrappers.forEach(wrapper => {
   
    const discountTexts = wrapper.querySelectorAll('.appstle_sellingPlan_discountText');
    
    discountTexts.forEach(item => {
      const percentageMatch = item.textContent.match(/(\d+)%/);
      if (percentageMatch && !item.textContent.includes('more')) {
        item.textContent = `${item.textContent} more!`;
      }
    });
  
  });
});
  
  observer.observe(document.body, {
    childList: true, 
    subtree: true
  });